// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xDK4","col":"styles_col__3J7pE"};